"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formField = void 0;
const tw_1 = require("../utils/tw");
exports.formField = (0, tw_1.tw)(`
  group relative w-fit
  [&:has([role=checkbox])]:flex [&:has([role=checkbox])]:items-center
  [&:has([role=checkbox])]:justify-center [&:has([role=checkbox])]:gap-sm
`);
